export const getDuration = (item) => {
  return (
    item?.video?.videoDuration ||
    // this is either a detail that doesn't have a video on it: an exhibitor, creator, promo, etc. OR it is missing the duration but is supposed to be there
    null
  )
}
